var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#2C3765"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6602 23.9584C39.8852 24.2952 39.0652 24.517 38.2261 24.617C39.1079 24.1006 39.7711 23.2803 40.0912 22.3099C39.2575 22.7974 38.3469 23.1394 37.3984 23.3214C36.9991 22.9028 36.5187 22.5698 35.9866 22.3427C35.4546 22.1155 34.8818 21.9989 34.3033 22C31.9609 22 30.0654 23.868 30.0654 26.1708C30.0637 26.4911 30.1004 26.8104 30.1747 27.122C28.4951 27.0433 26.8504 26.6148 25.3458 25.864C23.8413 25.1132 22.51 24.0566 21.4372 22.7619C21.0608 23.3963 20.8618 24.1203 20.8608 24.858C20.8608 26.3042 21.6154 27.5826 22.7547 28.3315C22.0797 28.3155 21.4185 28.1368 20.8273 27.8107V27.8623C20.8273 29.8853 22.2907 31.5682 24.2276 31.9513C23.8634 32.0484 23.488 32.0976 23.1111 32.0977C22.8436 32.0981 22.5767 32.0722 22.3144 32.0202C22.8528 33.6773 24.42 34.8825 26.2764 34.9169C24.7679 36.0794 22.9159 36.7078 21.0115 36.7032C20.6734 36.7027 20.3357 36.6825 20 36.6429C21.9374 37.88 24.1895 38.5344 26.4882 38.5281C34.2943 38.5281 38.5589 32.1708 38.5589 26.6572C38.5589 26.4764 38.5541 26.2956 38.5455 26.1191C39.3733 25.5303 40.0893 24.7986 40.6602 23.9584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.8e531d0964ca51e47995a923e23303d0.svg";
export { ForwardRef as ReactComponent };